import PasswordComponent from '@components/Password/PasswordComponent.vue';
import { Vue, axios } from '@master';

const manageRegisterPage = new Vue({
    el: '#manage_register_page',
    data() {
        return {
            registering: false,
            businessId: null,
            businessName: null,
            hasDomainRestriction: false,
            registration: {},
            code: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            password: "",
            confirm: ""
        }
    },
    methods: {
        submit() {
            this.errors.clear();
            this.registering = true;
            let postBody = {
                businessId: this.businessId,
                code: this.code,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.fullEmail,
                phone: this.phone,
                password: this.password,
                confirm: this.confirm
            };

            axios.post(`/${this.registration.url}/register`, postBody).then(response => {
                this.registering = false;
                this.swalSuccess("You have registered successfully.\nYou will receive an email shortly telling you to verify your email address.\nYou must verify your email address before you can login.", "Congrats!",[
                    {
                        value: "OK",
                        handler: () => {
                            window.location.href = '/';
                        }
                    }
                ])
            }).catch(error => {
                this.registering = false;
                if(error.status == 422) {
                    let errors = error.data.errors;
                    for(let field in errors) {
                        this.$validator.errors.add({
                            field: field,
                            msg: errors[field][0],
                            scope: this.$options.scope
                        });
                    }
                } else {
                    this.swalError(error.data.message, 'Error registering.');
                }
            });
        }
    },
    mounted() {
        this.setTitle(`${this.businessName} - Register`);
    },
    computed: {
        formIsInvalid() {
            return Object.keys(this.fields).some(key => {
                return this.fields[key].invalid;
            });
        },
        fullEmail() {
            if(this.hasDomainRestriction == true) {
                return `${this.email}@${this.domainRestriction}`;
            } else {
                return this.email;
            }
        }
    },
    components: {
        'password': PasswordComponent
    }
});
